import React from "react"

const news = () => {
  return <div>News</div>
}

export default news
